<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="['update', 'create'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{ formProps.editType === 'create' ? '隐患排查计划新增' : '隐患排查计划编辑' }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患排查计划详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="计划基本信息" name="baseInfo">
            <el-form
              ref="planForm"
              label-width="150px"
              :model="planForm"
              v-loading="loading"
              :disabled="!['update', 'create'].includes(formProps.editType)"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    label="计划名称"
                    prop="planName"
                    ref="planName"
                    :rules="[
                      {
                        required: true,
                        message: '请输入计划名称',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="planForm.planName"
                      placeholder="请输入计划名称"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    ref="planType"
                    label="计划类型"
                    prop="planType"
                    :rules="[
                      { required: true, message: '请输入计划类型', trigger: ['change', 'blur'] },
                    ]"
                  >
                    <el-select
                      class="w-full"
                      placeholder="请输入排查类型"
                      v-model="planForm.planType"
                      clearable
                    >
                      <el-option
                        v-for="item in checkTypeList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    label="组织单位"
                    prop="organizationalUnitId"
                    ref="organizationalUnitId"
                    :rules="[
                      {
                        required: true,
                        message: '请选择组织单位',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <MultipleDepart
                      :showCheckbox="false"
                      v-model="planForm.organizationalUnitId"
                      placeholder="请选择组织单位"
                      @change="changeDepartment"
                      :disabled="formProps.editType === 'read'"
                    ></MultipleDepart>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    label="组织负责人"
                    ref="headOrganizationId"
                    prop="headOrganizationId"
                    :rules="[
                      {
                        required: true,
                        message: '请输入组织负责人',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="planForm.headOrganizationId"
                      class="w-full"
                      placeholder="请选择责任人"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    label="被检查单位"
                    ref="unitBeingInspected"
                    prop="unitBeingInspected"
                    :rules="[
                      {
                        required: true,
                        message: '请输入被检查单位',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <MultipleDepart
                      v-model="planForm.unitBeingInspected"
                      placeholder="请选择被检查单位"
                      :disabled="formProps.editType === 'read'"
                    ></MultipleDepart>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <el-form-item
                    label="排查日期"
                    ref="dateArr"
                    prop="dateArr"
                    :rules="[
                      {
                        required: true,
                        validator: validatorDateArr,
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="planForm.dateArr"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetimerange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="dateChange"
                      :picker-options="pickerOptions"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-form-item label="整体排查目标" prop="overallTroubleshootingGoals">
                    <el-input
                      maxlength="500"
                      show-word-limit
                      type="textarea"
                      :rows="3"
                      v-model="planForm.overallTroubleshootingGoals"
                      placeholder="请输入整体排查目标"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="排查风险点信息" name="riskLevelControl">
            <el-tabs v-model="activeName">
              <el-tab-pane label="设备设施类" name="equip">
                <el-badge slot="label" :value="equipCount" :max="99" :hidden="false">
                  设备设施类
                </el-badge>
                <CheckPlanEquipTable
                  @sumCount="sumCount"
                  :planId="formData.id"
                  :formProps="formProps"
                  ref="equip"
                />
              </el-tab-pane>
              <el-tab-pane label="作业活动类" name="job">
                <el-badge slot="label" :value="jobCount" :max="99" :hidden="false">
                  作业活动类
                </el-badge>
                <CheckPlanJobTable
                  @sumCount="sumCount"
                  :planId="formData.id"
                  :formProps="formProps"
                  ref="job"
                />
              </el-tab-pane>
              <el-tab-pane label="基础管理类" name="base">
                <el-badge slot="label" :value="baseCount" :max="99" :hidden="false">
                  基础管理类
                </el-badge>
                <CheckPlanBaseTable
                  @sumCount="sumCount"
                  :planId="formData.id"
                  :formProps="formProps"
                  ref="base"
                />
              </el-tab-pane>
            </el-tabs>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div
        class="flex justify-center mt-20px"
        v-if="['update', 'create'].includes(formProps.editType)"
      >
        <el-button type="primary" size="small" @click="submitForm('publish')" :loading="loading"
          >发布</el-button
        >
        <el-button type="primary" size="small" @click="submitForm('save')" :loading="loading"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import uuid from 'uuid'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { HiddenDangerInvestigationPlanApi } from '@wiz-api/double-prevention-management'
import MultipleDepart from '@/components/safety/DepartmentSelect/MultipleDepart'

import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import CheckPlanEquipTable from './CheckPlanEquipTable'
import CheckPlanJobTable from './CheckPlanJobTable'
import CheckPlanBaseTable from './CheckPlanBaseTable'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const hiddenDangerInvestigationPlanApi = new HiddenDangerInvestigationPlanApi()

export default {
  name: 'control-equip-form',
  components: {
    MultipleDepart,
    CheckPlanEquipTable,
    CheckPlanJobTable,
    CheckPlanBaseTable,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      departmentList: [],
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
      checkTypeList: [{ displayName: '测试', code: 1 }],
      activeName: 'equip',
      planForm: {
        dateArr: [],
        headOrganizationId: '',
      },
      tableData: [],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk', 'riskLevelControl'],
      controlHierarchyList: [],
      userList: [],
      equipCount: 0,
      jobCount: 0,
      baseCount: 0,
    }
  },
  watch: {
    activeName(value) {
      this.$nextTick(() => {
        this.$refs[value].$refs.table.doLayout()
      })
    },
  },
  computed: {},
  async created() {
    // 新增页面获取默认值
    if (this.formProps.editType === 'create') {
      // 获取当前用户的部门信息
      await this.getDepartment()
    }
    this.planForm = {
      ...this.planForm,
      ...JSON.parse(JSON.stringify(this.formData)),
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.CheckType',
      ],
      ['controlHierarchyList', 'checkTypeList'],
      this
    )
    if (this.planForm.organizationalUnitId) {
      this.getUserList()
    } else {
      this.planForm.headOrganizationId = ''
      this.userList = []
    }
    if (this.planForm.investigationTimeStart && this.planForm.investigationTimeEnd) {
      this.planForm.dateArr = [
        new Date(this.planForm.investigationTimeStart),
        new Date(this.planForm.investigationTimeEnd),
      ]
    }
  },
  mounted() {},

  methods: {
    validatorDateArr(rule, value, callback) {
      if (!value || !value.length) {
        callback(new Error('排查日期不能为空!'))
        return
      }
      if (new Date(value[0]) <= new Date()) {
        callback(new Error('开始时间必须大于当前时间!'))
        return
      }
      if (value[0] >= value[1]) {
        callback(new Error('结束时间必须大于开始时间!'))
        return
      }
      callback()
    },
    sumCount(parse) {
      this[parse.key] = parse.value
    },
    // 切换责任部门
    changeDepartment(val) {
      if (val) {
        this.getUserList()
      } else {
        this.userList = []
      }
      this.planForm.headOrganizationId = ''
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.planForm.organizationalUnitId,
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 获取用户列表
    async getDepartment() {
      // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      const userId = sub
      const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({
        id: userId,
      })
      if (!err) {
        if (res?.orgUnits && res?.orgUnits.length > 0) {
          this.getUserList()
          this.planForm.organizationalUnitId = res.orgUnits[0].organizationUnitId
          this.planForm.headOrganizationId = userId
        }
      }
    },
    submitForm(type) {
      this.$refs.planForm.validate(async (valid, object) => {
        // 时间格式处理
        if (valid) {
          this.planForm.creationTime = this.planForm.creationTime
            ? dayjs(this.planForm.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : this.planForm.creationTime
          this.planForm.deletionTime = this.planForm.deletionTime
            ? dayjs(this.planForm.deletionTime).format('YYYY-MM-DD HH:mm:ss')
            : this.planForm.deletionTime
          this.planForm.investigationTimeStart = this.planForm.investigationTimeStart
            ? dayjs(this.planForm.investigationTimeStart).format('YYYY-MM-DD HH:mm:ss')
            : this.planForm.investigationTimeStart
          this.planForm.investigationTimeEnd = this.planForm.investigationTimeEnd
            ? `${dayjs(this.planForm.investigationTimeEnd).format('YYYY-MM-DD HH:mm:ss')}`
            : this.planForm.investigationTimeEnd
          this.planForm.planPublishTime = this.planForm.planPublishTime
            ? dayjs(this.planForm.planPublishTime).format('YYYY-MM-DD HH:mm:ss')
            : this.planForm.planPublishTime
          const planBasicManagementChecklistDtos = this.$refs.base.getSelectData()
          const planEquipmentFacilityChecklistsDtos = this.$refs.equip.getSelectData()
          const planJobActivityChecklistsDtos = this.$refs.job.getSelectData()
          if (
            !(
              planBasicManagementChecklistDtos &&
              planEquipmentFacilityChecklistsDtos &&
              planJobActivityChecklistsDtos
            )
          ) {
            this.$message({
              type: 'warning',
              showClose: true,
              message: '请校验勾选排查人',
            })
            return
          }
          if (
            !planBasicManagementChecklistDtos.length &&
            !planEquipmentFacilityChecklistsDtos.length &&
            !planJobActivityChecklistsDtos.length
          ) {
            this.$message({
              type: 'warning',
              showClose: true,
              message: '请至少勾选一个风险点',
            })
            return
          }
          this.loading = true
          delete this.planForm.dateArr
          const data = {
            hiddenDangerInvestigationDto: {
              ...this.planForm,
            },
            planBasicManagementChecklistDtos,
            planEquipmentFacilityChecklistsDtos,
            planJobActivityChecklistsDtos,
          }
          if (type === 'publish') {
            data.hiddenDangerInvestigationDto.planStatus = true
          }
          const api =
            this.formProps.editType === 'create'
              ? 'createHiddenDangerInvestigationPlan'
              : 'updateHiddenDangerInvestigationPlan'
          const [err, res] = await hiddenDangerInvestigationPlanApi[api]({ body: data })
          if (!err) {
            this.$emit('refreshList')
            this.$emit('cancel')
          }
          this.loading = false
        } else {
          // 验证不通过定位到第一个错误的地方
          const keyList = Object.keys(object)
          if (keyList && keyList.length) {
            const el = this.$refs[keyList[0]].$el
            el.scrollIntoView(true)
          }
        }
      })
    },
    createRow() {
      // this.$refs.riskIdentify.createRow()
      this.$refs.controlMeasure.createRow()
    },
    // 日期改变
    dateChange(value) {
      if (value && value.length) {
        this.planForm.investigationTimeStart = dayjs(value[0]).format('YYYY-MM-DD HH:mm:ss')
        this.planForm.investigationTimeEnd = dayjs(value[1]).format('YYYY-MM-DD HH:mm:ss')
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
